<template>
  <ModalCard>
    <template #header>
      <span class="is-hidden-mobile has-text-primary has-text-weight-semibold">
        <strong>{{ $t('estate.select-an-estate') }}</strong>
      </span>
    </template>
    <template #body>
      <section v-if="estates.length">
        <EstateSelectionBoxButton
          v-for="estate in clearEstates"
          :key="estate.id"
          :estate="estate"
          :selected="isCurrentEstate(estate)"
          @select-estate="onEstateClicked(estate)"
        />
        <Collapse v-if="clearVaults.length" :open="isClearVaultSelected">
          <template #header>
            {{ $t('estate.show-in-planning') }}
          </template>
          <EstateSelectionBoxButton
            v-for="vault in clearVaults"
            :key="vault.id"
            :estate="vault"
            :selected="isCurrentEstate(vault)"
            @select-estate="onEstateClicked(vault)"
          />
        </Collapse>
        <LoadingView :active="isChangingEstate" :is-full-page="false" />
      </section>
      <EstateSelectionModalSkeleton v-else />
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '/@/modules/core/ui/components/ModalCard.vue';
import EstateSelectionModalSkeleton from '/@/modules/estate/components/skeletons/EstateSelectionModalSkeleton.vue';
import EstateChangeEstateService from '/@/modules/estate/services/EstateChangeEstateService';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import { EstateRoute } from '/@/modules/estate/constants/EstateRoute';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import Collapse from '/@/modules/core/app/components/Collapse.vue';
import EstateSelectionBoxButton from '/@/modules/estate/components/EstateSelectionBoxButton.vue';
import LoadingView from '@/modules/core/ui/components/wrappers/LoadingView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EstateSelectionModal',
  mixins: [HasCurrentEstateMixin],
  components: {
    EstateSelectionBoxButton,
    EstateSelectionModalSkeleton,
    ModalCard,
    Collapse,
    LoadingView
  },
  data() {
    return {
      estates: [],
      isChangingEstate: false
    };
  },
  computed: {
    clearEstates() {
      return this.estates.filter((estate) => estate.isClearEstate);
    },
    clearVaults() {
      return this.estates.filter((estate) => estate.isClearVault);
    },
    isClearVaultSelected() {
      return (
        this.currentEstate &&
        this.estates.find((estate) => estate.id === this.currentEstate.id)?.isClearVault
      );
    }
  },
  methods: {
    async loadEstates() {
      this.estates = await EstateChangeEstateService.getEstates();
    },
    /**
     * @param {Estate} estate
     */
    async onEstateClicked(estate) {
      try {
        this.isChangingEstate = true;
        await EstateChangeEstateService.changeEstate(estate);
        DocumentUIService.reloadAppAtPath(EstateRoute.DASHBOARD);
      } finally {
        this.isChangingEstate = false;
      }
    },
    isCurrentEstate(estate) {
      return this.currentEstate?.id === estate.id;
    }
  },
  mounted() {
    this.loadEstates();
  }
};
</script>

<style scoped>
:deep(.collapse-trigger .trigger) {
  padding-left: 0;
}
</style>
